// @file Composable to encapsulate button skin based Tailwind classes for buttons on the surface
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfaceShareLinksStore } from '@@/pinia/surface_share_links'
import { useSurfaceTranslationsStore } from '@@/pinia/surface_translations_store'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

export const useSurfaceButtonSkinBasedTwClasses = (): Record<string, boolean | any> => {
  const surfaceStore = useSurfaceStore()
  const { isMobileLayout, isSkinColorAvailable, isSkinPrimaryColorDark } = storeToRefs(surfaceStore)
  const { isBreakout } = storeToRefs(useSurfaceShareLinksStore())
  const surfaceTranslationsStore = useSurfaceTranslationsStore()
  const { isViewingTranslatedPadlet } = storeToRefs(surfaceTranslationsStore)

  const buttonSkinBasedTailwindClasses = computed(() => {
    if (isBreakout.value && !isViewingTranslatedPadlet.value) {
      return {}
    }

    if (isMobileLayout.value) {
      return {
        'aria-disabled:!bg-transparent': true,
      }
    }

    if (!isSkinColorAvailable.value) {
      return {}
    }

    // isSkinPrimaryColorDark is either true or false here (cannot be 'auto') since we checked for isSkinColorAvailable
    return {
      // Base
      'bg-grey-1000 bg-opacity-5': !isSkinPrimaryColorDark.value,
      'bg-white-100 bg-opacity-10': isSkinPrimaryColorDark.value,
      'text-dark-text-200': !isSkinPrimaryColorDark.value,
      'text-light-text-200': isSkinPrimaryColorDark.value,

      // Hovered
      'hover-hover:hover:bg-opacity-10': !isSkinPrimaryColorDark.value,
      'hover-hover:hover:bg-opacity-15': isSkinPrimaryColorDark.value,

      // Disabled
      'aria-disabled:!bg-highway-400': !isSkinPrimaryColorDark.value,
      'aria-disabled:!bg-white-disabled': isSkinPrimaryColorDark.value,
    }
  })

  const buttonSkinBasedTailwindClassesWithoutHover = computed(() => {
    if (isBreakout.value) {
      return {}
    }

    if (isMobileLayout.value) {
      return {
        'aria-disabled:!bg-transparent': true,
      }
    }

    if (!isSkinColorAvailable.value) {
      return {}
    }

    return {
      // Base
      'bg-grey-1000 bg-opacity-5': !isSkinPrimaryColorDark.value,
      'bg-white-100 bg-opacity-10': isSkinPrimaryColorDark.value,
      'text-dark-text-200': !isSkinPrimaryColorDark.value,
      'text-light-text-200': isSkinPrimaryColorDark.value,

      // Disabled
      'aria-disabled:!bg-highway-400': !isSkinPrimaryColorDark.value,
      'aria-disabled:!bg-white-disabled': isSkinPrimaryColorDark.value,
    }
  })
  return { buttonSkinBasedTailwindClasses, buttonSkinBasedTailwindClassesWithoutHover }
}
